import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSlogan } from "../../redux/actions/orderActions";
import { DashboardLayout } from "../../Pages/dashboard/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaQuoteLeft } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import SearchBar from "../../Pages/Components/SearchBar";
import SortableTable from "../../Pages/Components/SortableTable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";

const SloganList = () => {
  const dispatch = useDispatch();
  const { updateLoading, fetchLoading, slogans, updateError } = useSelector((state) => state.slogan);
  const { userInfo } = useSelector((state) => state.auth);
  console.log("userInfo:", userInfo);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const navigate = useNavigate();
  const { access_modules } = useSelector((state) => state.dealerAccess);
  const sloganPerms = access_modules?.data?.find(
    (m) => m.alias === "slogans" || m.name === "Slogans"
  );
  const canCreate = !!sloganPerms?.is_create;
  const canRead = !!sloganPerms?.is_read;

  console.log("sloganPerms:", sloganPerms); // ✅ verify



  useEffect(() => {
    if (userInfo?.access_token) {
      dispatch(fetchSlogan(userInfo.access_token));
    }
  }, [dispatch, userInfo?.access_token]);

  if (!canRead && access_modules?.data) {
    return (
      <DashboardLayout>
        <div className="text-center py-20">
          <p className="text-red-500 font-bold text-lg">Access Denied</p>
          <p className="text-gray-500 text-sm mt-2">You don't have permission to view Slogans.</p>
        </div>
      </DashboardLayout>
    );
  }

  if (updateError) {
    const errorMessage =
      typeof updateError === "object" && updateError !== null
        ? updateError.message || updateError.status || JSON.stringify(updateError)
        : updateError;

    return (
      <DashboardLayout>
        <div className="mt-2 max-w-full mx-auto rounded-lg p-4">
          <p className="text-red-600 font-bold text-center">Error: {errorMessage}</p>
        </div>
      </DashboardLayout>
    );
  }

  const sloganArray = Array.isArray(slogans) ? slogans : slogans ? [slogans] : [];

  const filteredSlogans = sloganArray
    .filter((slogan) => {
      const search = searchValue.toLowerCase();
      const message = slogan.message?.toLowerCase() || "";
      const type = slogan.type?.toLowerCase() || "";
      return message.includes(search) || type.includes(search);
    })
    .filter((slogan) => {
      if (!startDate && !endDate) return true;
      const createdDate = dayjs(slogan.created_at); // ISO parses directly
      if (!createdDate.isValid()) return false;
      const start = startDate ? dayjs(startDate).startOf("day") : null;
      const end = endDate ? dayjs(endDate).endOf("day") : null;
      if (start && createdDate.isBefore(start)) return false;
      if (end && createdDate.isAfter(end)) return false;
      return true;
    })

  const columns = [
    { label: "Message", key: "message" },
    { label: "Type", key: "type" },
    { label: "Status", key: "is_active" },
    { label: "Created At", key: "created_at" },
  ];

  const renderRow = (slogan) => (
    <tr
      key={slogan.slogan_id || slogan.id}
      className="hover:bg-blue-50 hover:text-gray-950 hover:font-semibold"
    >
      <td className="px-2 py-4 border-b border-gray-400 text-sm max-w-xs">
        <span className="line-clamp-2">{slogan.message || "-"}</span>
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        <span className="capitalize bg-amber-100 text-amber-700 text-xs font-semibold px-2 py-0.5 rounded-full">
          {slogan.type || "slogans"}
        </span>
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        <span
          className={`text-xs font-semibold px-2 py-0.5 rounded-full ${slogan.is_active
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-700"
            }`}
        >
          {slogan.is_active ? "Active" : "Inactive"}
        </span>
      </td>
      <td className="px-2 py-4 border-b border-gray-400 text-sm">
        {slogan.created_at ? dayjs(slogan.created_at).format("DD MMM YYYY") : "-"}
      </td>
    </tr>
  );

  return (
    <DashboardLayout>
      <div className="mt-2 max-w-full mx-auto rounded-lg p-2">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <button onClick={() => navigate(-1)} className="hover:text-gray-800">
              <FaArrowLeft size={20} />
            </button>
            <h2 className="text-2xl font-bold text-amber-600">Slogans List</h2>
          </div>

          <div className="flex space-x-2">

            {canCreate && (
              <button
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 flex items-center px-4 py-2 text-sm font-medium text-white border border-amber-600 rounded-lg transition shadow-md hover:shadow-lg"

                onClick={() => navigate("/dashboard/createslogan")}
              >
                Create Slogan
              </button>
            )}
          </div>
        </div>

        {/* Filters */}
        <div className="mt-4 flex flex-wrap items-center mb-4 justify-between gap-4">
          <div className="w-2/3 flex flex-wrap gap-4 items-center">
            <SearchBar
              value={searchValue}
              onChange={setSearchValue}
              placeholder="Search by Message / Type"
            />
            <div className="relative w-1/3">
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                isClearable
                placeholderText="Select date range"
                dateFormat="dd MMM yyyy"
                className="placeholder-gray-500 w-full px-4 py-2 border border-gray-500 rounded-md text-sm"
              />
            </div>
          </div>
        </div>

        {/* Table */}
        {fetchLoading ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">Loading...</p>
        ) : filteredSlogans.length === 0 ? (
          <p className="font-bold text-md text-center text-gray-950 py-6">
            No slogans found
          </p>
        ) : (
          <SortableTable columns={columns} data={filteredSlogans} renderRow={renderRow} />
        )}
      </div>
    </DashboardLayout>
  );
};

export default SloganList;